



























































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";

import ImageJson, { imageDataUrlMaxLength, defaultImageJson } from "../../shared/ImageJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateImageJson, validateImageJsonAdd } from "../../shared/ImageJson";
import TableView from "../controls/TableView.vue";

export default Vue.extend({
  name: "ImageSelectBase64",
  components: {
    Loading,
    TableView,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    data: Array as PropType<ImageJson[]>,
    accept: Array as PropType<string[]>,
    multiple: Boolean,
    hideAltText: Boolean,
    enableClickPrevImg: Boolean,
    editable: Boolean,
    validation: Object,
    submitValidation: Boolean,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      imageDataUrlMaxLength: imageDataUrlMaxLength,
      details: [] as ImageJson[],
      overlayPictureViewerImgUrl: "",
      hasChanges: false,
      hintChanged: {},
      toValidate: {} as any,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.details = this.data;

      if (this.details.length <= 0 && !this.multiple) {
        this.addFile();
      }
    },

    async selectFile(e: Event & { target: HTMLInputElement }, index: number) {
      if (this.details != null) {
        if (e.target && e.target.files && e.target.files.length > 0) {
          let file = e.target.files[0] as File;

          if (!file.type.match(this.accept.join("|"))) {
            alert("Der ausgewählte Dateityp wird nicht unterstützt.");
            return;
          }

          if (file.size > this.imageDataUrlMaxLength) {
            alert("Die Datei darf maximal 10 MB groß sein. Bitte wählen Sie eine andere Datei aus.");
            return;
          }

          try {
            this.details[index].url = await this.convertFileToBase64(file);
          } catch (e) {
            this.details[index].url = "";
            alert("Es ist ein Fehler aufgetreten: " + e);
          }
        }
      }
    },

    addFile() {
      if (this.details) {
        this.details.push({ ...defaultImageJson() });
      }
    },

    removeFile(index: number) {
      this.details.splice(index, 1);

      delete this.toValidate["file-" + index];
    },

    //START set cached data

    //END set cached data

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      this.$emit("validateInput", "image", key);

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    /* inputValidation(key: any, prop: any, index: number) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.details != null) {
        this.validation[index] = validateImageJson(this.details[index]);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    }, */

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    async convertFileToBase64(file: File): Promise<string> {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = function () {
          if (reader != null) {
            resolve(reader.result as string);
          }
        };

        reader.onerror = function (error) {
          reject(error);
        };
      });
    },
  },

  watch: {
    data: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },

    /* submitValidation: function () {
      if (this.submitValidation) {
        if (this.details != null) {
          for (let i = 0; i < this.details.length; i++) {
            this.validation[i] = validateImageJson(this.details[i]);
          }
        }
      }
    }, */
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    formatAccept() {
      return this.accept.map((i: string) => "." + i).join(",");
    },
  },
});
